// ============================================
// CustomerFileColumnModel.tsx - 更新后的列模型
// ============================================

import React from 'react'
import { urlKey } from '../../../../services/api/api-urls'
import { getColModelItem } from '../../../../services/lib/utils/helpers'
import FilePreviewCell from './FilePreviewCell'

const CustomerFileColumnModel = () => {
  return [
    {
      ...getColModelItem({
        title: 'Type',
        field: urlKey.Employee,
        keywords: [
          urlKey.Employee
        ]
      }, () => ([{key: urlKey.Employee, label: '', otherOptions: {type: 'select', isOverrideSelectionOptions: true, valueJoinArray: ['firstName', 'lastName']}}]))
    },
    {
      title: 'Name',
      align: 'left',
      field: 'attachmentName'
    },
    {
      title: 'Description',
      align: 'left',
      field: 'attachmentDesc'
    },
    {
      // 先展开 getColModelItem 的配置
      ...getColModelItem({
        title: 'File',
        field: 'urls',
        keywords: ['urls']
      }, () => ([{key: 'urls', label: 'File', otherOptions: {type: 'image'}}])),
      // 然后覆盖 render 方法
      align: 'left',
      render: (rowData: any) => {
        try {
          if (!rowData.urls) {
            return <span style={{ color: '#999' }}>无文件</span>
          }

          // 处理 urls 字段，支持多文件（用 --- 分隔）
          let urlsString = rowData.urls
          if (typeof urlsString !== 'string') {
            urlsString = JSON.stringify(urlsString)
          }

          // 分割多个文件（用 --- 分隔）
          const fileStrings = urlsString.split('---').map((s:any) => s.trim()).filter((s:any) => s)
          const files: Array<{url: string, name: string}> = []

          // 解析每个文件
          fileStrings.forEach((fileStr:any) => {
            try {
              const fileData = JSON.parse(fileStr)
              if (fileData.url) {
                files.push({
                  url: fileData.url,
                  name: fileData.name || rowData.attachmentName || '未命名文件'
                })
              }
            } catch (e) {
              // 如果不是 JSON，尝试作为纯 URL
              if (fileStr.startsWith('http')) {
                files.push({
                  url: fileStr,
                  name: rowData.attachmentName || '未命名文件'
                })
              }
            }
          })

          if (files.length === 0) {
            return <span style={{ color: '#999' }}>无有效文件</span>
          }

          // 如果只有一个文件，直接显示预览按钮
          if (files.length === 1) {
            return (
              <FilePreviewCell 
                url={files[0].url} 
                fileName={files[0].name}
              />
            )
          }

          // 多个文件，显示文件列表
          return (
            <div style={{ display: 'flex', flexDirection: 'column', gap: '8px' }}>
              {files.map((file, index) => (
                <FilePreviewCell 
                  key={index}
                  url={file.url} 
                  fileName={file.name}
                />
              ))}
            </div>
          )
        } catch (error) {
          console.error('解析 URLs 失败:', error, rowData.urls)
          return <span style={{ color: '#f44336' }}>文件格式错误</span>
        }
      }
    }
  ]
}

export default CustomerFileColumnModel